<template>
	<div class="language-dropdown-container" :class="containerClasses.join(' ')">
		<div :class="['language-options-dropdown', {'landing-page-option' : $route.fullPath.includes('/landing')}]" ref="languagesDropdown">
			<span class="language-option" v-for="(language, index) in languages" :key="index"  @click="handleDropDownClick(language)">
				<img class="flag" :src="require(`@/common/assets/icons/flags/${language.short.toLowerCase()}.svg`)" :alt="language.name">
				<span>{{ language.name }}</span>

				<img class="arrow" :src="require(`@/drc/assets/icons/arrows/arrow-down-${containerClasses.includes('dark-mode') ? 'white' : 'gray'}.svg`)" alt="lang">
			</span>
		</div>
	</div>
</template>
<script>
	import { LANGUAGE_ARRAY } from "@/common/utils/constants.js";

	export default {
		name: "LanguageDropDown",
		props: {
			containerClasses: {
				required: false,
				type: Array,
				default: () => []
			},
			selectedLang: {
				required: true,
				type: Object
			}
		},
		data() {
			return {
				languages: [],
			}
		},
		methods: {
			handleDropDownClick(language) {
				this.$refs.languagesDropdown.classList.toggle("active");

				if (this.languages.length === 1) {
					this.fillLanguageOptions();
				} else {
					this.$emit("languageIsSelected", language);
					this.emptyLanguageOptions(language);
				}
			},
			fillLanguageOptions() {
				let langs = [];
				langs = LANGUAGE_ARRAY.filter((lang) => {
					if (this.selectedLang.short !== lang.short) {
						return lang;
					}
				});

				this.languages.push(...langs);
			},
			emptyLanguageOptions(language) {
				this.languages = [];
				// this.languages.push(this.selectedLang);
				this.languages.push(language)
			},
			toggleDropdown(event) {
				let target = event.target;
				if (target.parentNode && !target.parentNode.closest('.language-options-dropdown')) {
					this.$refs.languagesDropdown.classList.remove("active");
					this.emptyLanguageOptions(this.selectedLang);
				}
			},
		},
		mounted() {
			this.languages.push(this.selectedLang);
			document.addEventListener("click", this.toggleDropdown);
		},
		destroyed() {
			document.removeEventListener("click", this.toggleDropdown);
		}
	}
</script>

<style lang="sass">
.language-dropdown-container
	display: inline-block
	position: relative

	&.mt-30
		margin-top: 30px

	&.mobile
		@media (min-width: 769px)
			display: none

	.language-options-dropdown
		display: flex
		flex-direction: column
		width: 100%
		text-align: left

		&.active
			background: rgba(255, 255, 255, 0.79)
			box-shadow: 0 0 8px rgba(0, 0, 0, 2.5)
			position: relative
			top: 75px

			&.landing-page-option
				top: unset

		.language-option
			padding: 5px 10px
			cursor: pointer
			z-index: 10

			span
				vertical-align: middle
				font-family: 'Roboto', serif
				font-style: normal
				font-weight: 400
				font-size: 16px
				color: #011723

			.flag
				vertical-align: middle
				max-width: 22px
				margin-right: 5px

			.arrow
				display: none
				vertical-align: top
				max-width: 15px
				margin-left: 5px
				padding-top: 2px

			&:first-child
				&:hover
					background-color: transparent

				.arrow
					display: inline-block

			&:hover
				background-color: #FEF1D6

	&.dark-mode
		.language-option
			background-color: #212320

			span
				color: #fff

			&:hover
				background-color: #212320

				span
					color: #FEF1D6

	&.fixed-height
		height: 150px

</style>
